export class ProperPageResult<T> {
  totalItems: number;
  totalPages: number;
  pageNumber: number;
  items: T[];
}
